import React from 'react';
import { Button } from '@mui/material';

export const Columns = (deleteLocationVTItem) => [
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: 'Mã',
    width: 10,
    sort: true,
    align: 'center',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Tên địa điểm',
    align: 'center',
  },
  {
    id: 'nameEN',
    numeric: true,
    disablePadding: false,
    label: 'Địa điểm (tiếng Anh)',
    align: 'center',
  },
  {
    id: 'nameCN',
    numeric: true,
    disablePadding: false,
    label: 'Địa điểm (tiếng Hoa)',
    align: 'center',
  },
  {
    id: 'nameJP',
    numeric: true,
    disablePadding: false,
    label: 'Địa điểm (tiếng Nhật)',
    align: 'center',
  },
  {
    id: 'areaName',
    numeric: true,
    disablePadding: false,
    label: 'Khu vực',
    align: 'center',
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: 'Ghi Chú',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteLocationVTItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
